import { type CSSProperties } from 'react';

import styles from './MockDataBar.module.scss';

interface MockDataBarProps {
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
}

export const MockDataBar = ({ height, width }: MockDataBarProps) => {
  return (
    <div className={styles.bar} data-ui="mock-bar" style={{ height, width }} />
  );
};
